module.exports = __webpack_public_path__ + "0bd2af647a862432631e6914480e97c7.pdf";